import {
  RxListCompositeComponent,
  RxReactiveFormCompositeComponent,
  RxTextCompositeComponent,
} from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RxToggleComponent } from '@nrwl/rx-toggle';
import { RxUploadThumbnailComponent } from 'libs/rx-ui/src/lib/rx-upload-thumbnail/rx-upload-thumbnail/rx-upload-thumbnail.component';
import { Validators } from '@angular/forms';
import { rxRequiredValidator } from '@nrwl/rx-validators';

@Injectable({
  providedIn: 'root',
})
export class ContentDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public NewCategoryConfig(category) {
    return {
      panelClass: 'section-group-settings-popup',
      payload: {
        title: 'Content Group',
        tip: 'All Content Sections must belong to a Content Section Groups.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        data: category,
      },
    };
  }

  public NewCategory() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'Content Group',
        tip: 'All Content Sections must belong to a Content Section Groups.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Section Group Name',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 40,
            validators: [Validators.required, Validators.minLength(2), Validators.maxLength(40)],
            // asyncValidators: [this.formsValidatorsService.categoryUniqValidator(SearchType.AccountLibrary)]
          },
          {
            component: RxUploadThumbnailComponent,
            label: 'Group Thumbnail',
            value: null,
          },
          {
            component: RxToggleComponent,
            label: 'Age warning message',
            value: false,
          },
          {
            component: RxToggleComponent,
            label: 'Visible on Mobile App',
            value: true,
          },
          {
            component: RxToggleComponent,
            label: 'Visible on Web App',
            value: true,
          },
        ],
      },
    };
  }

  public NewCategoryItemConfig(category) {
    return {
      panelClass: 'section-settings-popup',
      payload: {
        title: 'Content Section',
        tip: 'All Content Sections must belong to a Content Section Groups.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        data: category,
      },
    };
  }

  public NewCategoryItem() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'Content Section',
        tip: 'All Content Sections must belong to a Content Section Groups.',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Section Name',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 40,
            validators: [Validators.required, Validators.minLength(2), Validators.maxLength(40)],
            // asyncValidators: [this.formsValidatorsService.categoryUniqValidator(SearchType.AccountLibrary)]
          },
          {
            component: RxUploadThumbnailComponent,
            label: 'Group Thumbnail',
            value: null,
          },
          // {
          //     component: RxToggleComponent,
          //     label: 'Published',
          //     value: false
          // }
        ],
      },
    };
  }

  public SelectCategory(items$: Observable<any[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Select Content Section Group',
        items$: items$,
        buttons: this.SubmitDismissButtons('Select'),
      },
    };
  }

  public confirmArchiveCategory() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Archive Content Section Group',
        tip: "Are you sure you want to archive this Content Section Group and remove all it's contents?",
        buttons: this.SubmitDismissButtons('Archive', 'Cancel'),
      },
    };
  }

  public confirmArchiveCategoryItem() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Archive Content Section',
        tip: "Are you sure you want to archive this Content Section and remove all it's contents?",
        buttons: this.SubmitDismissButtons('Archive', 'Cancel'),
      },
    };
  }

  public confirmRestoreCategory() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Restore Content Section Group',
        tip: 'Are you sure you want to restore this Content Section Group?',
        buttons: this.SubmitDismissButtons('Restore', 'Cancel'),
      },
    };
  }

  public confirmRestoreCategoryItem() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Restore Content Section',
        tip: 'Are you sure you want to restore this Content Section?',
        buttons: this.SubmitDismissButtons('Restore', 'Cancel'),
      },
    };
  }

  public askPassword(doctorId) {
    return {
      component: RxTextCompositeComponent,
      backdropClass: 'backdropBackgroundBlur',
      payload: {
        doctorId: doctorId,
        title: 'Archive Content Section',
        tip: 'Are you sure you want to restore this Content Section?',
        buttons: this.SubmitDismissButtons('Restore', 'Cancel'),
      },
    };
  }

  public confirmLeavingPage() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm Navigation',
        tip: 'You have unsaved changes. Are you sure you want to leave this page?',
        buttons: this.SubmitDismissButtons('Leave this Page', 'Stay on this Page'),
      },
    };
  }

  public confirmDiscardChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Discard Changes',
        tip: 'You have unsaved changes. Are you sure you want to leave this page?',
        buttons: this.SubmitDismissButtons('Discard', 'Cancel'),
      },
    };
  }

  public confirmSaveChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Unsaved changes.',
        tip: 'You have unsaved changes. Do you want to keep them ?',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public confirmSaveImageChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'You are about to delete unsaved changes. Press “Cancel” and save your changes or “Proceed” to discard unsaved changes.',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public confirmRemoveSelectedObject() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'You are about to delete selected item?',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public confirmRemoveAllObject() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'You are about to delete all items?',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public confirmDeletePage() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Delete Page',
        tip: "Are you sure you want to delete this page and remove all it's contents?",
        buttons: this.SubmitDismissButtons('Delete', 'Cancel'),
      },
    };
  }

  public editPage(sectionName: string) {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'Rename page',
        fields: [
          {
            placeholder: 'Page name',
            labelText: null,
            hasInlineInfo: true,
            value: sectionName,
            maxLength: 50,
            validators: [Validators.maxLength(50)],
          },
        ],
        buttons: this.SubmitDismissButtons(),
      },
    };
  }

  public save() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'New Page',
        placeholder: 'Page title',
        tip: 'TODO: Explanatory note',
        tipClose: false,
        buttons: this.SubmitDismissButtons(),
        fields: [
          {
            placeholder: 'Page title',
            labelText: null,
            hasInlineInfo: true,
            value: '',
            maxLength: 50, // DO NOT REMOVE, Used in form-editor and form-container
            validators: [rxRequiredValidator, Validators.minLength(2), Validators.maxLength(50)],
            // asyncValidators: [this.formsValidatorsService.formTemplateUniqValidator(SearchType.AccountLibrary)]
          },
        ],
      },
    };
  }

  public preview() {
    return {
      component: RxTextCompositeComponent,
      mobilePreviewComponent: RxTextCompositeComponent,
      panelClass: 'ipadPreview',
      width: '1280px',
      height: '800px',
      payload: {
        title: 'Form Preview',
        tip: 'TODO: Explanatory note',
        data: {},
        buttons: this.DismissButton('Close'),
      },
    };
  }
  public imgUpload(fileType = 'form') {
    return {
      component: RxTextCompositeComponent,
      panelClass: 'rx-img-upload',
      disableClose: false,
      width: '500px',
      height: '200px',
      payload: {
        fileType: fileType,
        title: 'Form Preview',
        tip: 'TODO: Explanatory note',
        data: {},
        buttons: this.DismissButton('Close'),
      },
    };
  }

  public noValidVideoFormatAlert() {
    return {
      component: RxTextCompositeComponent,
      hideDialogClose: false,
      payload: {
        title: 'No valid video format',
        tip: 'Supported formats: MP4, MOV',
        buttons: this.DismissButton('OK'),
      },
    };
  }
}
